"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function createParser(matcher, replacer) {
  var regex = RegExp(matcher, 'g');
  return function (string) {
    // * throw an error if not a string
    if (typeof string !== 'string') {
      throw new TypeError("expected an argument of type string, but got ".concat(typeof styleObj === "undefined" ? "undefined" : _typeof(styleObj)));
    } // * if no match between string and matcher


    if (!string.match(regex)) {
      return string;
    } // * executes the replacer function for each match
    // ? replacer can take any arguments valid for String.prototype.replace


    return string.replace(regex, replacer);
  };
}

var _default = createParser;
exports["default"] = _default;